import { Color, Euler, useFrame, Vector3 } from "@react-three/fiber";
import React, { useEffect, useRef } from "react";

import * as THREE from 'three';
import { BufferGeometry, Mesh } from "three";

type HingeJoint = {
    axis: THREE.Vector3,
    position: THREE.Vector3,
    value: number
}

type FingerSegmentProps = {
    position?: Vector3,
    rotation?: Euler,
    color: Color,
    geometry?: BufferGeometry,
    joint: HingeJoint,
    joint2?: HingeJoint
}


export const FingerSegment = (props: React.PropsWithChildren<FingerSegmentProps>) => {
    const meshRef = useRef<Mesh>();
    useEffect(() => {

        if (!meshRef.current) {
            return;
        }

        const moveDir = props.joint.position.clone();
        moveDir.normalize();
        const moveDist = meshRef.current.position.distanceTo(props.joint.position);
        meshRef.current.translateOnAxis(moveDir, moveDist);

        meshRef.current.rotateOnAxis(props.joint.axis, props.joint.value);

        moveDir.multiplyScalar(-1);
        meshRef.current.translateOnAxis(moveDir, moveDist);

        if (props.joint2) {
            const moveDir = props.joint2.position.clone();
            moveDir.normalize();
            const moveDist = meshRef.current.position.distanceTo(props.joint2.position);
            meshRef.current.translateOnAxis(moveDir, moveDist);

            meshRef.current.rotateOnAxis(props.joint2.axis, props.joint2.value);

            moveDir.multiplyScalar(-1);
            meshRef.current.translateOnAxis(moveDir, moveDist);
        }
    }, []);

    return (
        <mesh ref={meshRef} position={props.position} rotation={props.rotation}>
            {props.geometry &&
                <>
                    <primitive object={props.geometry} attach="geometry" />
                    <meshStandardMaterial color={props.color} />
                </>
            }
            {props.children}
        </mesh>
    );
};
